import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraOrganiser = ({ data }) => {
  const navigate = useNavigate();

  const defaultData = {
    title: "Become A Nabora Organiser",
    subtitle:
      "Build local digital ecosystems and bring neighbourhood businesses together.",
    benefits: [
      {
        icon: "🎪",
        title: "Host Exhibitions",
        desc: "Create and manage monthly neighbourhood exhibitions.",
      },
      {
        icon: "👥",
        title: "Build Local Network",
        desc: "Connect merchants, creators and customers.",
      },
      {
        icon: "🚀",
        title: "Youth Entrepreneurship",
        desc: "Create opportunities through digital commerce.",
      },
      {
        icon: "💜",
        title: "Powered By PurpleDoor BOS",
        desc: "Use behavioural growth systems to build communities.",
      },
    ],
  };

  const content = data || defaultData;

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="py-8 px-6 bg-gradient-to-br from-violet-950 via-purple-950 to-slate-950">
        <div className="max-w-5xl mx-auto text-center">
          <div className="uppercase tracking-[4px] text-yellow-300 text-sm mb-4">
            👥 NABORA ORGANISER
          </div>

          <h1 className="text-2xl lg:text-4xl font-bold mb-4">
            {content.title}
          </h1>

          <p className="text-slate-300 text-base lg:text-xl max-w-3xl mx-auto">
            {content.subtitle}
          </p>

          <button
            onClick={() => navigate("/nabora/organiser/register")}
            className="mt-6 px-6 py-3 rounded-xl bg-gradient-to-r from-fuchsia-500 to-violet-600 font-bold hover:scale-105 transition-all shadow-xl shadow-purple-500/40"
          >
            🚀 Join As Organiser
          </button>
        </div>
      </div>

      <div className="py-8 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-center text-xl lg:text-2xl font-bold text-cyan-200 mb-6">
            Why Become A Nabora Organiser?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {content.benefits.map((item, index) => (
              <div
                key={index}
                className="bg-slate-900/80 rounded-3xl p-6 border border-white/10 hover:border-purple-400/50 transition-all"
              >
                <div className="text-4xl mb-3">{item.icon}</div>

                <h3 className="text-gray-100 text-lg font-bold mb-2">{item.title}</h3>

                <p className="text-slate-300 text-sm lg:text-base">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-8 px-6 bg-gradient-to-br from-slate-900 to-violet-950">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-5xl mb-4">🌍</div>

          <h2 className="text-xl lg:text-3xl font-bold mb-3 text-cyan-200">
            Create Your Local Digital Economy
          </h2>

          <p className="text-slate-300 mb-6">
            Organisers become the bridge between neighbourhood businesses,
            customers and digital opportunities.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate("/nabora/exhibitions")}
              className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
            >
              🎪 Manage Exhibitions
            </button>

            <button
              onClick={() => navigate("/foundher")}
              className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
            >
              💜 Join FoundHer Network
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NaboraOrganiser;
